import React from 'react';
import {EDIDialog} from './EDICompaniesDialog';

const ediDlgRef: React.RefObject<EDIDialog> = React.createRef();

export async function renderEdiCompDialog(root) {
    root.render(<EDIDialog ref={ediDlgRef} />);
    return ediDlgRef;
}
